/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import { Fragment, useEffect, useState } from "react";

import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Badge from "@material-ui/core/Badge";
import PaymentIcon from "@material-ui/icons/Payment";

import PerfectScrollbar from "react-perfect-scrollbar";

import { useStoreon } from "storeon/react";
import Link from "@material-ui/core/Link";

const GreenCheckbox = styled(Checkbox)`
  svg {
    color: green !important;
  }
`;

const OrdersListWrap = styled.ul`
  margin: 0px;

  > li {
    padding: 5px;
    color: #eee;
    margin: 0px;
    position: relative;
    border-bottom: 1px solid #595959;
    display: flex;
    justify-content: left;
    > div {
      font-size: 13px;
      padding: 3px;
      display: flex;
      align-items: left;
      flex-direction: column;
      justify-content: center;
      > a {
        font-size: 15px;
      }
    }
    > div > img {
      width: 80px;
      height: auto;
    }
    :hover {
      background: #555;
    }
    svg {
      cursor: pointer;
    }
  }
`;

const OrderItem = props => {
  const { active, onClick, onAdd, onRemove, usedCount } = props;
  const {
    orderId,
    preview,
    count,
    date,
    size,
    paid,
    user,
    productId,
    productSKU
  } = props.order;
  return (
    <li
      className={active ? "active" : ""}
      onClick={() => {
        onClick && onClick(props.order);
      }}
    >
      <div>
        <img src={preview} alt={orderId} />
      </div>
      <div>
        <div style={{ fontSize: "14px", marginBottom: "5px" }}>
          <Link
            href={`/wp-admin/post.php?post=${orderId}&action=edit`}
            target="_blank"
          >
            <b>{`#${orderId} `}</b>
          </Link>
          <Link
            href={`/wp-admin/post.php?post=${productId}&action=edit`}
            target="_blank"
          >
            <b style={{ color: "#4e6bff" }}>{productSKU}</b>
          </Link>
          <b> {date}</b>
          <PaymentIcon
            color={paid ? "primary" : "disabled"}
            style={{ position: "absolute", right: 10 }}
          />
        </div>
        <div>
          Kunde:{" "}
          <b>
            {user.firstName} {user.lastName}
          </b>
        </div>
        <div>
          Größe:{" "}
          <b>{`${Math.round(size.width * 0.1)}x${Math.round(
            size.height * 0.1
          )}cm`}</b>
        </div>
        <div>
          Menge:{" "}
          <b>
            {usedCount}/{count}
          </b>
        </div>
        {/* <div>{paymentMethod}</div> */}
        <div style={{ position: "absolute", right: 10, bottom: 10 }}>
          <Badge
            anchorOrigin={{
              vertical: "top",
              horizontal: "left"
            }}
            badgeContent={count - usedCount}
            color="error"
          >
            <Badge badgeContent={usedCount} color="primary">
              <ButtonGroup color="primary">
                <Button
                  onClick={_ => {
                    if (usedCount < props.order.count) {
                      onAdd(props.order);
                    }
                  }}
                >
                  +
                </Button>
                <Button
                  onClick={_ => {
                    if (usedCount > 0) {
                      onRemove(props.order);
                    }
                  }}
                >
                  -
                </Button>
              </ButtonGroup>
            </Badge>
          </Badge>
        </div>
      </div>
    </li>
  );
};

const OrdersList = () => {
  const { dispatch, canvas, orders } = useStoreon("canvas", "id", "orders");
  const [activeOrders, setActiveOrders] = useState([]);
  const [selected, setSelected] = useState([]);
  useEffect(
    _ => {
      if (!canvas) return;
      const handlePrintplateChanges = () => {
        const orders = canvas.getObjects().filter(o => o.order);
        setActiveOrders(orders);
      };
      handlePrintplateChanges();
      canvas.on({
        "object:removed": handlePrintplateChanges,
        "object:added": handlePrintplateChanges
      });
    },
    [canvas]
  );

  const handleAdd = order => {
    canvas.DPE.printplate.addOrder(order);
  };

  const handleRemove = order => {
    const targetObj = canvas
      .getObjects()
      .find(obj => obj.order && order.itemId === obj.order.itemId);
    if (targetObj) {
      canvas.remove(targetObj);
    }
  };

  const productSKUs = [...new Set(orders.map(order => order.productSKU))];

  const filteredOrders = selected.length
    ? orders.filter(o => selected.includes(o.productSKU))
    : orders;

  return (
    <Fragment>
      <Select
        style={{ minWidth: 330, background: "white", padding: "0 10px" }}
        multiple
        value={selected}
        onChange={e => setSelected(e.target.value)}
        input={<Input id="select-multiple-chip" />}
        displayEmpty
        renderValue={selected => {
          if (!selected.length) {
            return "Select products to filter";
          }
          return selected.join(", ");
        }}
      >
        {productSKUs.map(SKU => (
          <MenuItem key={SKU} value={SKU}>
            <GreenCheckbox checked={selected.indexOf(SKU) > -1} />
            <ListItemText primary={SKU} />
          </MenuItem>
        ))}
      </Select>
      <PerfectScrollbar style={{ height: "calc(100% - 40px)" }}>
        <OrdersListWrap>
          {filteredOrders.map(order => {
            const usedCount = activeOrders.filter(
              o => o.order.itemId === order.itemId
            ).length;
            return (
              <OrderItem
                dispatch={dispatch}
                order={order}
                key={order.itemId}
                canvas={canvas}
                usedCount={usedCount}
                // active={id === editor.id}
                onAdd={handleAdd}
                onRemove={handleRemove}
              />
            );
          })}
        </OrdersListWrap>
      </PerfectScrollbar>
    </Fragment>
  );
};

export default OrdersList;
